import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'context/AuthContext';
import { RegionProvider } from 'context/RegionContext';
import AppRouter from "./routes/AppRouter";
import NativeQuoteBridge from 'components/muyeon/NativeQuoteBridge';
import NativeAddressBridge from 'components/muyeon/NativeAddressBridge';
import ActiveTypeGateHost from 'components/ui/ActiveTypeGateHost';
import IdentityRequiredHost from 'components/ui/IdentityRequiredHost';
import ForceLogoutHost from 'components/ui/ForceLogoutHost';
import AcademyNamePrompt from 'components/ui/AcademyNamePrompt';
import LandingCtaHost from 'components/ui/LandingCtaHost';
import AlertOptInHost from 'components/muyeon/AlertOptInHost';
import MaintenancePopup from 'components/ui/MaintenancePopup';
import GlobalNetworkOverlay from 'components/ui/GlobalNetworkOverlay';
import AppToastHost from 'components/ui/AppToastHost';
import AppOnlyModalHost from 'components/ui/AppOnlyModalHost';
import ScrollToTop from 'components/ui/ScrollToTop';
import maintenanceConfig from 'config/maintenanceConfig';


function App() {
  useEffect(() => {
    // 공개 이미지의 브라우저 기본 저장 진입점(우클릭·길게 누르기·드래그)을 전역 차단한다.
    const blockImageAction = (event) => {
      if (event.target instanceof Element && event.target.closest('img')) event.preventDefault();
    };
    document.addEventListener('contextmenu', blockImageAction);
    document.addEventListener('dragstart', blockImageAction);
    return () => {
      document.removeEventListener('contextmenu', blockImageAction);
      document.removeEventListener('dragstart', blockImageAction);
    };
  }, []);

  return (
    <AuthProvider >
      <RegionProvider>
        <MaintenancePopup
          isActive={maintenanceConfig.isActive}
          title={maintenanceConfig.title}
          description={maintenanceConfig.description}
          schedule={maintenanceConfig.schedule}
          content={maintenanceConfig.content}
        />
        <GlobalNetworkOverlay />
        <AppToastHost />
        <AppOnlyModalHost />
        <BrowserRouter>
          <ScrollToTop />
          <NativeQuoteBridge />
          <NativeAddressBridge />
          <ActiveTypeGateHost />
          <IdentityRequiredHost />
          <ForceLogoutHost />
          <AcademyNamePrompt />
          <LandingCtaHost />
          <AlertOptInHost />
          <AppRouter />
        </BrowserRouter>
      </RegionProvider>
    </AuthProvider>
  );
}

export default App;
